import type { DefaultFeatureFlagValue, FeatureFlagValue } from '../../common/types.tsx';
import { _haveValuesArrived } from '../get-all-feature-flags/index.tsx';

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports, jira/export/restrict-types-re-export
export type { FeatureFlagValue } from '../../common/types';

/**
 * @deprecated Use `expVal` or `fg` instead - see https://hello.atlassian.net/wiki/spaces/JFP/pages/3382881038/Jira+Playbook+Statsig for more details.
 *
 * @param defaultValue boolean 'true' value is not allowed go/ff-default
 */
export function getFeatureFlagValue<T extends FeatureFlagValue>(
	_featureFlagName: string,
	defaultValue: T extends DefaultFeatureFlagValue ? T : never,
): T {
	return defaultValue;
}

/**
 * @param defaultValue No other values allowed other than false go/ff-default
 */
export const ff = (featureFlagName: string, defaultValue: false = false): boolean => {
	const flagValue = getFeatureFlagValue(featureFlagName, defaultValue);

	const isValid = typeof flagValue === 'boolean';

	return isValid ? flagValue : defaultValue;
};

/**
 * @deprecated Use `expVal` instead - see https://hello.atlassian.net/wiki/spaces/JFP/pages/3382881038/Jira+Playbook+Statsig for more details.
 */
export const getMultivariateFeatureFlag = <T extends string>(
	featureFlagName: string,
	defaultValue: T,
	possibleValues: Readonly<T[]>,
): T => {
	const flagValue = getFeatureFlagValue<T>(
		featureFlagName,
		// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
		defaultValue as T extends DefaultFeatureFlagValue ? T : never,
	);

	const isValid = typeof flagValue === 'string' && possibleValues.includes(flagValue);

	return isValid ? flagValue : defaultValue;
};
